import React from 'react';
import getApplicantInformationLabel from '@/Utils/getLabelsFunctions';
import ApplicantInformationType from '@/Models/ApplicantInformationType';
import InfoChoiceSelector from './components/InfoChoiceSelector';
import UIStrings from '@/Utils/UIStrings';
import { AccordionContent, AccordionItem } from '@/Components/shadcn';
import RequestInformationAccordionTrigger from './components/RequestInformationAccordionTrigger';

const motivationalInformationToggles: ApplicantInformationType[] = [
    ApplicantInformationType.ReasonForApplying,
    ApplicantInformationType.ReasonForLeaving,
];

const MotivationalInformatioAccordion = () => {
    return (
        <AccordionItem value={UIStrings.MotivationalInformation}>
            <RequestInformationAccordionTrigger>{UIStrings.MotivationalInformation}</RequestInformationAccordionTrigger>
            <AccordionContent>
                {motivationalInformationToggles.map((value) => (
                    <InfoChoiceSelector
                        key={ApplicantInformationType[value]}
                        label={getApplicantInformationLabel(value)}
                        name={value}
                    />
                ))}
            </AccordionContent>
        </AccordionItem>
    );
};

export default MotivationalInformatioAccordion;
